import { IServiceProviderActivity } from "@/interfaces/dashboard.interface";
import { cn } from "@/lib/class-control";

interface ActivityLogCardProps {
  activities: IServiceProviderActivity[];
}

const statusColorMap = {
  red: 'bg-[#DC4426]',
  green: 'bg-[#13D480]',
  yellow: 'bg-[#E2AF10]',
};

export default function ActivityLogCard({ activities }: ActivityLogCardProps) {
  return (
    <div className="bg-[#15203C] rounded-[20px] p-[30px] flex flex-col gap-[40px]">
      {/* Title */}
      <h2 className="text-[18px] font-bold text-white">Backlog de Infos do Projeto</h2>

      {/* Timeline Entries */}
      <div className="flex flex-col gap-[24px]">
        {activities.map((activity, index) => (
          <div key={activity.id}>
            <div className="flex gap-[24px]">
              {/* Date + Dot */}
              <div className="flex items-center gap-[12px] w-[160px] flex-shrink-0">
                <p className="text-[16px] text-[#F6F6F6] w-[141px]">{activity.date}</p>
                <div
                  className={cn(
                    "size-[12px] rounded-full",
                    statusColorMap[activity.status]
                  )}
                />
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col gap-[24px]">
                <div className="flex flex-col gap-[5px]">
                  <p className="text-[16px] font-bold text-[#F6F6F6] leading-[1.5]">
                    {activity.title}
                  </p>
                  <p className="text-[16px] text-[#F6F6F6] leading-[1.5]">
                    By:{" "}
                    <span className="text-[#A085FF] underline decoration-solid">
                      {activity.author}
                    </span>
                  </p>
                </div>
                <p className="text-[16px] text-[#B0B0B0] leading-[1.5]">
                  {activity.description}
                </p>
              </div>
            </div>

            {/* Divider - Don't show after last item */}
            {index < activities.length - 1 && (
              <div className="border-b border-gray-800/60 mt-[24px]" />
            )}
          </div>
        ))}

        {/* Empty State */}
        {activities.length === 0 && (
          <p className="text-center text-gray-400 text-sm py-8">
            Nenhuma atividade registrada
          </p>
        )}
      </div>
    </div>
  );
}
